export { createManuscriptPanel, DEFAULT_LABELS } from './manuscript-panel.js';
export { createZoomController, ZOOM_DEFAULTS } from './zoom.js';
export { nearestEntry } from './resolve.js';
export * as bbox from './bbox.js';

// Selection core + layer registry: the substrate every apparatus plugs into.
export { createSelection } from './selection.js';
export { createDock, DOCK_LABELS } from './dock.js';
export { createLayerRegistry } from './layers.js';
export { createCommentaryPanel, COMMENTARY_LABELS } from './commentary-panel.js';
export * as address from './address.js';
